import styled from 'styled-components';
import {
  flexbox,
  alignItems,
  flexDirection,
  justifyContent
} from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const Wrapper = styled.span(() => `
  ${flexbox()};
  ${flexDirection('column')};

  box-sizing: border-box;
  font-size: 12px;
  position: relative;
  height: fit-content;

  &:last-child {
    border-right: none;
  }
`);

const FixedWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  position: sticky;
  top: 1px;
  z-index: 6;
  border-top: 1px solid ${colours.grey[400]};
  border-right: 2px solid ${colours.grey[500]};
`;
});

const StandardWrapper = styled.div((props) => {
  const LEARNING_JOURNEY_WIDTH = 54;
  const { lj } = props;
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${justifyContent('space-between')};

    width: ${lj * LEARNING_JOURNEY_WIDTH}px;
    min-height: 40px;
    height: 40px;
    background-color: #c3d5e1
    border: ${lj > 0 ? `1px solid ${colours.grey[400]}` : 'none'};
    border-right: ${lj > 0 ? `1px solid ${colours.grey[500]}` : 'none'};
    border-top: none;
    box-sizing: border-box;
    font-size: 12px;
    overflow: hidden;
    cursor: pointer;
`;
});

const LearningJourneyWrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};

    height: 150px;
    font-size: 12px;
    background-color: #eaf9f9;
    color: ${colours.grey[800]};
`;
});

const CollapsedWrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};

    font-size: 12px;
    width: 54px;
    border-right: 1px solid ${colours.grey[500]};
`;
});

const Content = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};
    ${justifyContent('center')};

    width: calc(100% - 23px);
    padding-left: 2px;
    color: ${colours.grey[800]};
`;
});

const TopicName = styled.div((props) => {
  const { palette } = ThemeHelper.getTheme(props);

  return `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${palette.primary.dark};
`;
});

const ExternalKey = styled(TopicName)`
    text-transform: uppercase;
`;

const Icon = styled.div`
    ${flexbox()};
    ${alignItems('center')};

    cursor: pointer;
    height: 40px;

    [class^="svgIconComponent"] {
      width: 15px !important;
    }

    &:hover {
      path {
        fill: #3b4e5e !important;
      }
    }

    &:active {
      path {
        fill: #000 !important;
      }
    }
`;

const IconDropdown = styled(Icon)`
  margin-left: 5px;
`;

const Info = styled.div`
  ${flexbox()};
  ${justifyContent('space-between')};

  width: calc(100% - 17px);
  padding: 1px;
`;

export {
  Wrapper,
  ExternalKey,
  TopicName,
  Icon,
  IconDropdown,
  Content,
  StandardWrapper,
  LearningJourneyWrapper,
  Info,
  FixedWrapper,
  CollapsedWrapper
};
